import React, { useEffect, useState } from 'react';
import { css } from '@emotion/css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { InfoPaginate } from 'models/commonModel';

interface Props {
    infoPage: InfoPaginate | null;
    onChangePage: (type: 'proPage' | 'nextPage' | 'btnSearch' | number) => void;
    showTotal?: boolean;
    isLightTheme?: boolean;
}

const Pagination: React.FC<Props> = ({ infoPage, onChangePage, showTotal, isLightTheme }) => {
    const [rangeDisplayPage, setRangeDisplayPage] = useState(5);

    // Xử lý responsive hiển thị số page
    useEffect(() => {
        const changeViewPagination = () => {
            if (window.innerWidth < 767) {
                setRangeDisplayPage(3);
            } else {
                setRangeDisplayPage(5);
            }
        };

        changeViewPagination();
        window.addEventListener('resize', changeViewPagination);

        return () => window.removeEventListener('resize', changeViewPagination);
    }, []);

    if (!infoPage || infoPage.totalpage <= 1) {
        return null;
    }

    // Tạo danh sách số trang hiển thị
    const pages: number[] = [];
    const start = Math.max(1, infoPage.curpage - Math.floor(rangeDisplayPage / 2));
    const end = Math.min(infoPage.totalpage, start + rangeDisplayPage - 1);

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <div className={styles.wrap}>
            <div className={`${styles.pagination} ${isLightTheme ? styles.light : ''}`}>
                {/* Nút Prev */}
                <button
                    onClick={() => onChangePage('proPage')}
                    disabled={infoPage.curpage <= 1}
                >
                    <FaArrowLeft size={16} />
                </button>

                {/* Số trang */}
                {pages.map((p) => (
                    <button
                        key={p}
                        className={p === infoPage.curpage ? 'active' : ''}
                    >
                        {p}
                    </button>
                ))}

                {/* Nút Next */}
                <button
                    onClick={() => onChangePage('nextPage')}
                    disabled={infoPage.curpage >= infoPage.totalpage}
                >
                    <FaArrowRight size={16} />
                </button>
            </div>

            {showTotal && (
                <div className={styles.totalRecord}>
                    Tổng số: {new Intl.NumberFormat().format(infoPage.totalrecord)}
                </div>
            )}
        </div>
    );
};

export default Pagination;

const styles = {
    wrap: css`
        padding-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
    pagination: css`
        display: flex;
        align-items: center;
        gap: 6px;
        button {
            cursor: pointer;
            padding: 5px 10px;
            border-radius: 6px;
            border: 1px solid #ccc;
            background: #fff;
            &.active {
                background: linear-gradient(to bottom, #1b53f0, #011e98);
                color: #fff;
                font-weight: bold;
            }
            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            &:hover:not(:disabled) {
                background: #f0f0f0;
            }
        }
    `,
    light: css`
        button {
            background: #f9f9f9;
            border-color: #ddd;
            color: #333;
            &.active {
                background: #333;
                color: #fff;
            }
        }
    `,
    totalRecord: css`
        font-size: 14px;
        color: #555;
        margin-left: 10px;
    `,
};
